import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { CurrencyRatioPageContainer } from './CurrencyRatioPageContainer';
import { actions } from './CurrencyRatioPageContainer.actions';
import {
    getSelectOptions,
    getCurrenciesList
} from './CurrencyRatioPageContainer.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    selectOptions: getSelectOptions,
    currenciesList: getCurrenciesList
});

const CurrencyRatioPageContainerComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            location: state.routingCompat,
            loading: state.currencyRatios.loading,
            totalPages: state.currencyRatios.total,
            currency: state?.user?.publisher?.account?.balance?.currency || ''
        };
    },
    null
)(CurrencyRatioPageContainer);

export default CurrencyRatioPageContainerComponent;
